module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Shiloh, April 6, 1862")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429968911_i0022.jpg",
      "src": "e9781429968911_i0022.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Shiloh, April 7, 1862")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429968911_i0023.jpg",
      "src": "e9781429968911_i0023.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_fullpage_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Siege of Vicksburg, May 18–July 4, 1863")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fullpage_image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429968911_i0024.jpg",
      "src": "e9781429968911_i0024.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Battles at Chattanooga, November 23-25, 1863")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429968911_i0025.jpg",
      "src": "e9781429968911_i0025.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Grant Battles Lee in Virginia, 1864-1865")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429968911_i0026.jpg",
      "src": "e9781429968911_i0026.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_fullpage_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sherman’s Marches, 1864-1865")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fullpage_image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429968911_i0027.jpg",
      "src": "e9781429968911_i0027.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f55296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429968911_fm02.vue
// module id = 72
// module chunks = 0